// core
import { Component, OnInit, Renderer2, Inject } from '@angular/core';

// campfire
import { matDialog, MatDialogRef } from '@campfire-nx/material';
import { ScriptLoaderService } from '@campfire-nx/api';
import { PartnerBrandService } from '@campfire-nx/api';

// services
import { RaptorActionService } from '../../../resources/raptor-action.service';


@Component({
  selector: 'open-raptor-medical-interstitial',
  templateUrl: './raptor-medical-interstitial.component.html',
  styleUrls: ['./raptor-medical-interstitial.component.scss']
})
export class RaptorMedicalInterstitialComponent implements OnInit {
  scripts: any = {
    uat: {
      uk: 'https://blackbox30-traveluat.verisk.co.uk/scripts/blackbox-3.1.0.js',
      au: 'https://blackbox30-traveluat.verisk.com.au/scripts/blackbox-3.1.0.js'
    },
    prod: {
      uk: 'https://blackbox30-travel.verisk.co.uk/scripts/blackbox-3.1.0.js',
      au: 'https://blackbox30-travel.verisk.com.au/scripts/blackbox-3.1.0.js'
    }
  };
  endpoints: any = {
    uat: {
      uk: 'https://gatewayuat.verisk.com/rating/au/travel/', // uk development endpoint is returning a 403, so pointing to AU instead
      au: 'https://gatewayuat.verisk.com/rating/au/travel/'
    },
    prod: {
      uk: 'https://gateway.verisk.com/rating/uk/travel/',
      au: 'https://gateway.verisk.com/rating/au/travel/'
    }
  };

  initialLocation!: string;

  constructor(
    private scriptLoaderService: ScriptLoaderService,
    private partnerBrandService: PartnerBrandService,
    private raptorActionService: RaptorActionService,
    private renderer: Renderer2,
    public dialogRef: MatDialogRef<RaptorMedicalInterstitialComponent>,
    @Inject('environment') private environment: any,
    @Inject(matDialog.MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    let questionControl = this.data.form.get(this.data.question.key);
    if (questionControl.value) {
      // resume screening
      this.raptorActionService
        .getMedicalCondition(this.data.question.settings.data_url + '/' + questionControl.value)
          .then((response: any) => {
            this.renderVerisk(response?.value);
          })
    } else {
      // new screening
      this.renderVerisk();
    }
    
    this.initialLocation = window.location.href;
  }

  // I may return the result to this function so that I can update the form
  onClose(result?: any) {
    if (!result) {
      window.history.replaceState(null, '', this.initialLocation);  
    }
    
    setTimeout(() => {
      this.dialogRef.close(true);
    }, 100);

    // hack to trigger the teardown of the event listeners in the Verisk widget
    setTimeout(() => {
      let overlay: HTMLCollection = document.getElementsByClassName('verisk-overlay');
      if (overlay.length) {
        let event = new MouseEvent('click', {bubbles: true});
        overlay[0].dispatchEvent(event);
      }
    }, 200);
  }

  renderVerisk(condition?: string) {
    let product =  this.partnerBrandService.getAttribute('product', 'partner');
    let scriptSrc = this.scripts[this.environment.production ? 'prod' : 'uat'][product.country?.country_alpha3 === 'AUS' ? 'au' : 'uk'];
    let endpointUrl = this.endpoints[this.environment.production ? 'prod' : 'uat'][product.country?.country_alpha3 === 'AUS' ? 'au' : 'uk'];
    let veriskScript = document.getElementById('verisk-blackbox');

    (window as any).API_VERSION = (window as any).API_VERSION || 'v2';
    (window as any).ROOT_URL = (window as any).ROOT_URL || endpointUrl;
    (window as any).HOSTPAGE_ROOT_URL = (window as any).HOSTPAGE_ROOT_URL || window.location.pathname;
    (window as any).USER_SETTINGS = this.data.question.settings.user_settings;
    if (condition) {
      (window as any).USER_SETTINGS.$G_ScreeningData = condition;
    }
    (window as any).AUTH_DATA = (window as any).AUTH_DATA ||
      {
        uri: `${this.environment.apiEndpoint}${this.data.question.settings.auth_token_url}`,
        config: {}
      };
    (window as any).EVENT_LISTENERS = {
      onFinish: this.onFinish,
      onError: this.onError
    };
    (window as any).RESULT_DESTINATION_VAR = (window as any).RESULT_DESTINATION_VAR || 'whatever';
    
    if (!veriskScript) {
      this.scriptLoaderService.loadJsScript(
        this.renderer,
        null,
        'text/javascript',
        scriptSrc,
        'verisk-blackbox'
      );
    } else if ((window as any).bb3Widget) {
      (window as any).bb3Widget.run();
    }
  }

  onFinish = (eventType: any, result: any): any => {
    let patchedValue: any = {};

    switch (eventType) {
      case 'COMPLETE_SCREENING':
        this.raptorActionService.saveMedicalCondition(this.data.question.settings.data_url, { value: result })
          .then((response) => {
            patchedValue[this.data.question.key] = response.slug;
            this.data.form.patchValue(patchedValue, { emitEvent: true });
            this.onClose(result);
          });
      break;
      case 'SAVE_SCREENING':
        this.raptorActionService.saveMedicalCondition(this.data.question.settings.data_url, { value: result })
          .then((response) => {
            patchedValue[this.data.question.key] = response.slug;
            this.data.form.patchValue(patchedValue, { emitEvent: true });
            this.onClose(result);
          });

      break;
      default:
      break;
    }
  }

  onError = (eventType: any, errors: any): any => {
    this.onClose(errors);
  }
}
